import InpostPayQuery from 'Query/InpostPay.query';
import {
    getInpostPayConfig,
} from 'Store/InpostPay/InpostPay.action';
import { fetchQuery } from 'Util/Request';

class InpostPayDispatcher {
    async getInpostPayConfig(dispatch) {
        const inpostPayQuery = new InpostPayQuery();
        const { storeConfig } = await fetchQuery(inpostPayQuery.getInpostPayConfig());
        dispatch(getInpostPayConfig(storeConfig));
    }
}

export default new InpostPayDispatcher();
